import { useState } from "react"
import { useTranslation } from "react-i18next"

/**
 * Renders a vertical list that collapses to `collapsedCount` items and shows a
 * "+N más / Ver menos" toggle when there are more. Used for table cells that may
 * carry one value (legacy single-picker / single-tote) or several (multi-task
 * REM / B2B orders with multiple pickers and totes).
 */
export const ExpandableList = ({ items = [], renderItem, collapsedCount = 1, className = "" }) => {
    const { i18n } = useTranslation()
    const [expanded, setExpanded] = useState(false)

    if (!Array.isArray(items) || items.length === 0) return null

    const hasOverflow = items.length > collapsedCount
    const visibleItems = expanded || !hasOverflow ? items : items.slice(0, collapsedCount)

    return (
        <div className={`flex flex-col gap-0.5 ${className}`}>
            {visibleItems.map((item, index) => renderItem(item, index))}
            {hasOverflow && (
                <button
                    type="button"
                    className="text-indigo-600 hover:text-indigo-900 text-xs text-left mt-0.5"
                    onClick={(e) => {
                        e.stopPropagation()
                        setExpanded((prev) => !prev)
                    }}
                >
                    {expanded
                        ? i18n.t("common.show_less")
                        : `+${items.length - collapsedCount} ${i18n.t("common.show_more")}`}
                </button>
            )}
        </div>
    )
}
